import { useEffect } from "react"

// Fires a jQuery AJAX GET whose `.js` response replaces DOM content elsewhere
// on the page. Rendering this via react_component (rather than an inline
// <script> tag) guarantees jQuery is already loaded by the time the request
// fires, since React only mounts components after the surrounding pack has
// finished executing.
export default function AjaxFormLoader({ url }) {
  useEffect(() => {
    $.get(url)
  }, [url])

  return null
}
